import { Directive, HostListener } from '@angular/core';
import { IWidgetConfig } from '@shared/models/site-config.interface';
import { SiteConfigService } from '@shared/shared/services/site-config.service';
import { USER_SELECTED_SITE } from 'app.config';

export enum MEDIA_QUERY_SIZES {
  DEFAULT = 'default',
  TABLET = 'tablet',
  MOBILE = 'mobile',
}

@Directive()
export abstract class BaseComponent {
  public abstract componentData;

  constructor(protected siteConfigService: SiteConfigService, protected path: string) {
    this.setComponentData();
    if (!localStorage.getItem(USER_SELECTED_SITE)) {
      this.setLocalStorage();
    }
  }

  @HostListener('window:resize')
  public setComponentData() {
    const initialComponentData: IWidgetConfig = this.siteConfigService.getComponentData(this.path);

    this.componentData = {
      ...initialComponentData.default,
      ...initialComponentData[this.getMediaQuery()],
    };
  }

  private getMediaQuery(): MEDIA_QUERY_SIZES {
    const currentWidth = window.innerWidth;

    if (currentWidth < 768) {
      return MEDIA_QUERY_SIZES.MOBILE;
    } else if (currentWidth < 1024) {
      return MEDIA_QUERY_SIZES.TABLET;
    } else {
      return MEDIA_QUERY_SIZES.DEFAULT;
    }
  }

  public setLocalStorage() {
    const sites = this.siteConfigService.sites;
    if (sites?.length === 1) {
      localStorage.setItem(USER_SELECTED_SITE, sites[0].site_id.toString());
    }
  }
}
